export default __webpack_public_path__ + "static/media/dollar-coins.6e89c6ba.png";